module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.aMenu._id,
      "id": "name",
      "placeholder": "Menu name",
      "data-field": "name"
    },
    domProps: {
      "value": _vm.aMenu.name
    },
    on: {
      "input": _vm.updateMenuFields
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "gender",
      "data-field": "gender"
    },
    domProps: {
      "value": _vm.aMenu.gender
    },
    on: {
      "change": _vm.updateMenuFields
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Gender--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "woman"
    }
  }, [_vm._v("Woman")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "man"
    }
  }, [_vm._v("Man")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "english-message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "english-message",
      "data-field": "message",
      "placeholder": "Message prefix (english)"
    },
    domProps: {
      "value": _vm.aMenu.message
    },
    on: {
      "change": _vm.updateMenuFields
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "swahili-message"
    }
  }, [_vm._v("Message (Swahili)")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "swahili-message",
      "data-field": "swahili",
      "placeholder": "Message prefix (swahili)"
    },
    domProps: {
      "value": _vm.aMenu.swahili
    },
    on: {
      "change": _vm.updateMenuFields
    }
  })]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Options")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.anOption.eng),
      expression: "anOption.eng"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "English option"
    },
    domProps: {
      "value": (_vm.anOption.eng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.anOption.eng = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.anOption.swa),
      expression: "anOption.swa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Swahili option"
    },
    domProps: {
      "value": (_vm.anOption.swa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.anOption.swa = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.anOption.nextStage),
      expression: "anOption.nextStage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Next stage"
    },
    domProps: {
      "value": (_vm.anOption.nextStage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.anOption.nextStage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "taggable": "",
      "options": _vm.smsapps
    },
    model: {
      value: (_vm.anOption.nextApps),
      callback: function($$v) {
        _vm.anOption.nextApps = $$v
      },
      expression: "anOption.nextApps"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.canAddOption
    },
    on: {
      "click": _vm.addOption
    }
  }, [_vm._v(_vm._s(_vm.addOptionCaption))])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('options', {
    on: {
      "edit": _vm.editAnOption
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.canSave
    },
    on: {
      "click": _vm.saveMenu
    }
  }, [_vm._v(_vm._s(_vm.saveCaption))]), _vm._v("\n       "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('br'), _c('br'), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-079b8552","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/new.vue
// module id = qh2Z
// module chunks = 1